<template>
  <TrusteeshipBanner />
  <TrusteeshipValue />
  <TrusteeshipHighlights />
  <TrusteeshipContent />
</template>

<script lang="ts" type="text/tsx">
import TrusteeshipBanner from '@template/page/planTrusteeship/planTrusteeshipBanner.vue';
import TrusteeshipValue from '_Project/application/template/page/planTrusteeship/planTrusteeshipValue.vue';
import TrusteeshipHighlights from '_Project/application/template/page/planTrusteeship/planTrusteeshipHighlights.vue';
import TrusteeshipContent from '@template/page/planTrusteeship/planTrusteeshipContent.vue';

export default {
  name: 'planTrusteeship',
  components: {
    TrusteeshipBanner,
    TrusteeshipValue,
    TrusteeshipHighlights,
    TrusteeshipContent
  },
    mounted(): void {
    $Store.Page().checkPointPlan($Enum.RouterEnum.PlanTrusteeship);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planTrusteeship/';
</style>